// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3FFjA","inputWrap":"styles_inputWrap__vXIDa","input":"styles_input__3JQBV"};